import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const TourContext = createContext(null);

export const TOUR_DONE_KEY = 'sw_tour_done';

export const TourProvider = ({ children }) => {
  const [activeTour, setActiveTour] = useState(null); // tour id string or null
  const [tourStepIndex, setTourStepIndex] = useState(0);
  const [tourRunning, setTourRunning] = useState(false);

  const startTour = useCallback((tourId) => {
    setActiveTour(tourId);
    setTourStepIndex(0);
    setTourRunning(true);
  }, []);

  const endTour = useCallback(() => {
    setTourRunning(false);
    setActiveTour(null);
    setTourStepIndex(0);
    localStorage.setItem(TOUR_DONE_KEY, 'true');
  }, []);


  const advanceStep = useCallback((index) => {
    setTourStepIndex(index);
  }, []);

  return (
    <TourContext.Provider value={{
      activeTour,
      tourStepIndex,
      tourRunning,
      startTour,
      endTour,
      advanceStep,
    }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => {
  const ctx = useContext(TourContext);
  if (!ctx) throw new Error('useTour must be used within a TourProvider');
  return ctx;
};

export default TourContext;
